export const SITE = {
  name: "Fundio",
  tagline: "Entdecken. Stöbern. Wiederverwenden.",
  phone: "+41317410193",
  phoneDisplay: "+41 31 741 01 93",
  mobile: "+41792245566",
  mobileDisplay: "+41 79 224 55 66",
  whatsapp: "41792245566",
  email: "info@fundio.ch",
  city: "Ueberstorf",
  address: "Chrummatt 111, CH-3182 Ueberstorf",
  region: "Schweiz",
  maps: "https://www.google.com/maps/search/?api=1&query=Chrummatt+111+CH-3182+Ueberstorf",
  hours: [
    ["Montag – Samstag", "12:00 – 17:00"],
    ["Sonntag", "Geschlossen"],
  ],
};

export const CATEGORIES = ["Möbel", "Haushalt", "Deko", "Werkzeug", "Elektro", "Antikes", "Saison", "Sonstiges"];
export const CONDITIONS = ["Neuwertig", "Sehr gut", "Gut", "Gebraucht", "Bastler"];

export const STATUS_LABELS = {
  draft: "Entwurf",
  review: "Prüfen nötig",
  available: "Verfügbar",
  reserved: "Reserviert",
  sold: "Verkauft",
  hidden: "Versteckt",
};

export const STATUS_DOT = {
  draft: "#9AA0A6",
  review: "#E0A82E",
  available: "#7B8C73",
  reserved: "#4A90B8",
  sold: "#4A4D50",
  hidden: "#636773",
};

export const waLink = (text) =>
  `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(text || "Hallo Fundio, ich interessiere mich für ein Fundstück.")}`;

export const formatPrice = (price) =>
  price || price === 0 ? `CHF ${Number(price).toLocaleString("de-CH")}` : "Preis auf Anfrage";

export const FALLBACK_IMG =
  "https://images.pexels.com/photos/3435212/pexels-photo-3435212.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
